import { Component } from '@angular/core';

@Component({
  selector: 'ingo-loader',
  template: '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {}
